import { useEffect, useState } from 'react';
//import { Overlay, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './ShareModal.scss';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  shortUrl: string;
}

const ShareModal: React.FC<ModalProps> = ({ isOpen, onClose, shortUrl }) => {
  const [copied, setCopied] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  // ! for language
  const { t } = useTranslation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (copied) setCopied(false);
      if (showTooltip) setShowTooltip(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [copied, showTooltip]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shortUrl);
    setCopied(true);
    setShowTooltip(true);
  };
  return isOpen ? (
    <div className="custom-modal">
      <div className="modal__dialog">
        <div className="modal__box">
          <div className="modal-header-custom">
            <div className="modal-title-area">
              <span className="modal-title-custom">{t('xref-share-results')}</span>
            </div>
            <div className="close-button-area">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={onClose}
              >
                ×
              </button>
            </div>
          </div>
          <div className="modal-body">
            <input id="searchInputField" className="dk-input" value={shortUrl} readOnly />
            <button
              className="copy-btn"
              id="copy-button"
              onClick={copyToClipboard}
            >
              <div style={{ position: 'relative', height: 22, width: 22 }}>
                <span className="icon-copy" style={copied ? { "color": "green" } : {}}></span>
              </div>
            </button>
          </div>
          <div className="close-btn-area">
            {' '}
            <button
              type="button"
                className="dk-btn__primary"
              data-dismiss="modal"
              onClick={onClose}
            >
              {t('xref-close')}
            </button>
            {/* tooltip */}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default ShareModal;
